import React from 'react';
import { FormDialog } from 'dialog';
import { getTempId } from 'utils';
import { PlusIcon } from 'components/icons';
import { FormOnSubmit } from 'components/form';
import { EditGatewayFormData } from 'containers/jobsiteConfiguration/types';
import { getDefaultValues, getFormInputs } from './AddGatewayModal.forms';
import { AddGatewayModalProps } from './types';

export function AddGatewayModal(
  props: AddGatewayModalProps,
): React.ReactElement {
  const { isOpen, onCancel, onConfirm, gateways } = props;

  const onSubmit: FormOnSubmit<EditGatewayFormData> = (
    data, // event, dirtyFields, formApi,
  ): void => {
    onConfirm?.({ id: getTempId(), ...data });
  };

  const formInputs = React.useMemo(
    () => getFormInputs({ gateways }),
    [gateways],
  );
  const defaultValues = React.useMemo(() => getDefaultValues(), []);

  return (
    <FormDialog
      id="addGateway"
      open={isOpen}
      setOpen={onCancel}
      title="Add Gateway"
      inputs={formInputs}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      inputsContainerClassName="odin-grid odin-grid-cols-6 odin-gap-6"
      actionText="Add Gateway"
      actionIcon={PlusIcon}
    />
  );
}
